/*
 * TimeSpanPlannerStep Messages
 *
 * This contains all the text for the TimeSpanPlannerStep container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.TimeSpanPlannerStep";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the TimeSpanPlannerStep container!",
  },
  noAvailableTimeSlots: {
    id: `${scope}.noAvailableTimeSlots`,
    defaultMessage: "No available time slots",
  },
  optionalScanner: {
    id: `${scope}.optionalScanner`,
    defaultMessage: "With scanner?",
  },
  kptOverrideTitle: {
    id: `${scope}.kptOverrideTitle`,
    defaultMessage: "KPT Override",
  },
  kptOverrideEmpty: {
    id: `${scope}.kptOverrideEmpty`,
    defaultMessage: "None",
  },
  differentDate: {
    id: `${scope}.differentDate`,
    defaultMessage:
      "Warning: Selected date is not available, see suggestions below.",
  },
});
